var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{directives:[{name:"scroll",rawName:"v-scroll",value:(_vm.disableActive),expression:"disableActive"}],staticClass:"highlight",class:{ active: _vm.isActive },on:{"click":_vm.toggleActive}},[_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1da189aa","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/subpages/Highlight.vue
// module id = 122
// module chunks = 0